import assert from 'assert';
import type { NextRouter } from 'next/router';
import { isNil } from 'es-toolkit';

import type { JWTContextUser } from '@savvy/deprecated-shared/api/user-api';
import type { XRouter } from '@savvy/deprecated-shared/hooks/use-router';
import { getClientStageRedirectRoute } from '@savvy/deprecated-shared/utils/routing';
import { isSafeRedirectUrl } from '@savvy/deprecated-shared/utils/routing/is-safe-redirect-url';

export function getReturnUrl(
  router: NextRouter | XRouter,
  user: JWTContextUser | null,
  isSmallScreen: boolean,
): string {
  const rawReturnUrl = router.query['returnUrl'];
  assert(
    typeof rawReturnUrl === 'string' || rawReturnUrl === undefined,
    `Invalid type of returnUrl in URL: ${typeof rawReturnUrl}`,
  );
  const returnUrl: string | undefined = typeof rawReturnUrl === 'string' ? rawReturnUrl : undefined;
  const isAdvisorSide = !isNil(user) && user.role !== 'CLIENT' && user.role !== 'NON_ADVISORY_USER';
  const isClient = user?.role === 'CLIENT';
  const personalPortfolioId =
    isSmallScreen && user?.role !== 'NON_ADVISORY_USER' ? user?.personalPortfolioId : undefined;
  const defaultReturnUrl = getDefaultReturnUrl(isAdvisorSide, isClient, personalPortfolioId);

  // Only use returnUrl if it's a safe internal path (prevents open redirect attacks)
  const safeReturnUrl = returnUrl !== undefined && isSafeRedirectUrl(returnUrl) ? returnUrl : undefined;

  return (
    safeReturnUrl ||
    getClientStageRedirectRoute(router.basePath + router.pathname, user, isSmallScreen) ||
    defaultReturnUrl
  );
}

function getDefaultReturnUrl(
  isAdvisorSide: boolean,
  isClient: boolean,
  personalPortfolioId: string | null | undefined,
): string {
  if (!isNil(personalPortfolioId)) {
    return `/savvy-portfolio/${personalPortfolioId}`;
  }
  if (isAdvisorSide) {
    return '/advisor/canvas';
  }
  if (isClient) {
    return '/dashboard';
  }
  return '/portfolio';
}
